require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-429-sum-of-squares-of-unitary-divisors.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-429-sum-of-squares-of-unitary-divisors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-429-sum-of-squares-of-unitary-divisors!./.cache/json/coding-interview-prep-project-euler-problem-429-sum-of-squares-of-unitary-divisors.json
// module id = 1722
// module chunks = 231608221292675